export const POSITION_MODEL = {
    LEFT:"LEFT",
    RIGHT:"RIGHT",
    TOP:"TOP",
    BOTTOM:"BOTTOM"
}

export const PLACEMENT_MODEL = {
    LEFT:"left",
    RIGHT:"right",
    TOP:"top",
    BOTTOM:"bottom"
}

